import Vue from 'vue';
// utils
import { toggleModal } from '../utils/modal';

// vue related imports/variables
import ProductVersionsInfo from '../components/ProductVersionsInfo';

Vue.component('product-versions-info', ProductVersionsInfo);

const componentEl = document.getElementById('product-versions-info');
let productVersionsInfoApp;

// other variables
const productVersions = document.querySelector(
  '.product-detail .product__versions',
);

const initVueComponent = () => {
  if (componentEl) {
    productVersionsInfoApp = new Vue({
      el: '#product-versions-info',
      data: {
        activeId: 0,
      },
      methods: {
        updateActiveId(id) {
          this.activeId = id;
        },
      },
      created() {
        // listen for custom events emitted from outside
        this.$on('update-active-id', this.updateActiveId);
      },
      comments: true,
    });
  }
};

const initModal = () => {
  // can't use toggleModal, bc need to get clicked link info
  const modal = productVersions.querySelector('.modal--versions-info');
  const buttons = productVersions.querySelectorAll(
    '.product-version__full-tech-info',
  );

  if (modal && buttons.length > 0) {
    buttons.forEach((btn) => {
      // toggle modal
      toggleModal(modal, btn);

      // add click listeners for getting the active data
      btn.addEventListener('click', ({ target }) => {
        const activeId = target.getAttribute('data-id');
        // emit the custom even with the data
        productVersionsInfoApp.$emit('update-active-id', +activeId);
      });
    });
  }
};

(() => {
  if (componentEl) {
    initVueComponent();
  }

  if (productVersions) {
    initModal();
  }
})();
